import { render } from "./nuezSettings.vue?vue&type=template&id=8b8b1c1c"
import script from "./nuezSettings.vue?vue&type=script&lang=js"
export * from "./nuezSettings.vue?vue&type=script&lang=js"
script.render = render

export default script